import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Trophy = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12.004 18.708v-3m6.246-10.25h1a2 2 0 0 1 2 2v.5a3 3 0 0 1-3 3m-12.5-5.5h-1a2 2 0 0 0-2 2v.5a3 3 0 0 0 3 3m6 5h.5a6 6 0 0 0 6-6v-4.5a2 2 0 0 0-2-2h-8.5a2 2 0 0 0-2 2v4.5a6 6 0 0 0 6 6m-3.25 6h7a1.75 1.75 0 1 0 0-3.5h-7a1.75 1.75 0 1 0 0 3.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.069 3.458a2.545 2.545 0 0 0-2.448 1.85h-.327A2.544 2.544 0 0 0 2.75 7.852v.462a3.47 3.47 0 0 0 2.978 3.435 6.25 6.25 0 0 0 5.582 4.642v.942H8.762a2.313 2.313 0 0 0 0 4.625h6.476a2.312 2.312 0 1 0 0-4.625h-2.54v-.942a6.25 6.25 0 0 0 5.574-4.642 3.47 3.47 0 0 0 2.978-3.435v-.462a2.544 2.544 0 0 0-2.544-2.544h-.327a2.545 2.545 0 0 0-2.448-1.85zM5.294 6.696h.231v3.468l.001.113a2.08 2.08 0 0 1-1.388-1.963v-.462c0-.639.517-1.156 1.156-1.156m14.569 1.618c0 .907-.58 1.678-1.389 1.963l.001-.113V6.696h.231c.639 0 1.157.517 1.157 1.156z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
